module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (44).ee860f00.jpg";